(() => {
  'use strict';
  function boot() {
    const configNode = document.getElementById('ph-colour-config');
    if (!configNode) return;
    let config;
    try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
    const picker = Array.from(document.querySelectorAll('variant-radios, variant-selects')).find(p => (p.dataset.url || '').split('/').pop() === config.handle);
    if (!picker || picker.dataset.colourBrowser) return;
    const data = picker.querySelector('script[data-variant]');
    if (!data) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch (_) { return; }
    const fields = Array.from(picker.querySelectorAll('fieldset'));
    const selects = Array.from(picker.querySelectorAll('select'));
    const field = fields[config.option - 1];
    const select = selects[config.option - 1];
    const nativeOptions = field ? Array.from(field.querySelectorAll('input[type="radio"]')) : select ? Array.from(select.options) : [];
    const rows = nativeOptions.map(input => {
      const matches = variants.filter(v => v.options[config.option - 1] === input.value);
      return {
        input,
        label: field ? field.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null,
        variants: matches,
        group: config.variants[String(matches[0]?.id)] || 'special'
      };
    });
    if (!rows.length || rows.some(r => !r.variants.length || (field && !r.label))) return;
    const fr = document.documentElement.lang.startsWith('fr');
    const t = fr ? {
      title: 'Trouvez votre nuance', level: '1. Choisissez une hauteur de ton', family: '1. Choisissez une famille', all: 'Toutes les nuances',
      search: 'Rechercher un code ou une nuance', example: 'Code ou nom de nuance', stock: 'En stock seulement',
      choose: '2. Choisissez votre nuance', count: 'nuances affichées', singular: 'nuance affichée', empty: 'Aucune nuance ne correspond à ces filtres.',
      reset: 'Réinitialiser les filtres', sold: 'Épuisé', selected: 'Nuance sélectionnée',
      outside: 'La nuance sélectionnée est hors des filtres. Choisissez une nuance ci-dessous pour la remplacer.', special: 'Nuances spéciales'
    } : {
      title: 'Find your shade', level: '1. Choose a level', family: '1. Choose a family', all: 'All shades',
      search: 'Search by shade code or name', example: 'Shade code or name', stock: 'In stock only',
      choose: '2. Choose your shade', count: 'shades shown', singular: 'shade shown', empty: 'No shades match these filters.',
      reset: 'Reset filters', sold: 'Sold out', selected: 'Selected shade',
      outside: 'Your selected shade is outside these filters. Choose a shade below to change it.', special: 'Specialty shades'
    };
    const prefix = `ph-colour-${picker.dataset.section}`;
    const box = document.createElement('section');
    box.className = 'ph-colour-browser';
    box.setAttribute('aria-label', t.title);
    const step = config.mode === 'level' ? t.level : t.family;
    box.innerHTML = `<h3>${t.title}</h3><div class="ph-colour-group-control"><p class="ph-colour-step">${step}</p><div class="ph-colour-levels" role="group" aria-label="${step}"></div></div><label class="ph-colour-search-label" for="${prefix}-search">${t.search}</label><input id="${prefix}-search" class="ph-colour-search" type="search" placeholder="${t.example}" autocomplete="off"><div class="ph-colour-tools"><label for="${prefix}-stock"><input id="${prefix}-stock" type="checkbox"> ${t.stock}</label><button type="button" class="ph-colour-reset">${t.reset}</button></div><p class="ph-colour-step ph-colour-choose">${t.choose}</p><p class="ph-colour-count" role="status" aria-live="polite"></p><p class="ph-colour-notice" hidden></p>`;
    const group = box.querySelector('.ph-colour-levels');
    const present = new Set(rows.map(r => r.group));
    const levels = Object.keys(config.groups).filter(g => present.has(g));
    if (present.has('special') && !levels.includes('special')) levels.push('special');
    const isSelected = row => field ? row.input.checked : row.input.selected;
    // Preserve the pilot's initial selected level; small or named ranges start with all shades.
    let active = config.mode === 'level' && rows.length > 12 ? rows.find(isSelected)?.group || 'all' : 'all';
    const buttons = ['all', ...levels].map(level => {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.level = level;
      button.textContent = level === 'all' ? t.all : config.groups[level]?.[fr ? 1 : 0] || t.special;
      button.addEventListener('click', () => { active = level; apply(); });
      group.appendChild(button);
      return button;
    });
    if (levels.length < 2) {
      box.querySelector('.ph-colour-group-control').hidden = true;
      box.querySelector('.ph-colour-choose').hidden = true;
    }
    const search = box.querySelector('input[type="search"]');
    const stock = box.querySelector('input[type="checkbox"]');
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[–—]/g, '-').replace(/,/g, '.').toLowerCase().trim();
    const available = row => row.variants.some(v => v.available && v.options.every((value,index) => {
      if (index === config.option - 1) return true;
      const chosen = fields[index]?.querySelector('input:checked')?.value ?? selects[index]?.value;
      return chosen === undefined || value === chosen;
    }));
    function apply() {
      const query = normalize(search.value);
      let count = 0;
      let selectedHidden = false;
      rows.forEach(row => {
        const inStock = available(row);
        const visible = (active === 'all' || row.group === active) && (!stock.checked || inStock) && normalize(row.input.value).includes(query);
        row.input.classList.toggle('ph-colour-filtered', !visible);
        if (row.label) {
          row.label.classList.toggle('ph-colour-filtered', !visible);
          row.badge.hidden = inStock;
        } else {
          row.input.hidden = !visible;
        }
        if (visible) count++;
        if (isSelected(row) && !visible) selectedHidden = true;
      });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.level === active)));
      box.querySelector('.ph-colour-count').textContent = count ? `${count} ${count === 1 ? t.singular : t.count}` : t.empty;
      const notice = box.querySelector('.ph-colour-notice');
      notice.hidden = !selectedHidden;
      notice.textContent = selectedHidden ? t.outside : '';
    }
    search.addEventListener('input', () => { active = 'all'; apply(); });
    stock.addEventListener('change', apply);
    box.querySelector('.ph-colour-reset').addEventListener('click', () => { active = 'all'; search.value = ''; stock.checked = false; apply(); });
    // The theme's existing handler continues to own variant selection, media, price and cart state.
    picker.addEventListener('change', apply);
    const legend = field?.querySelector('legend strong');
    if (legend) legend.textContent = `${t.selected}:`;
    rows.forEach(row => {
      if (!row.label) return;
      const badge = document.createElement('span');
      badge.className = 'ph-colour-sold';
      badge.textContent = t.sold;
      row.label.appendChild(badge);
      row.badge = badge;
    });
    picker.before(box);
    picker.classList.add('ph-colour-shades');
    picker.dataset.colourBrowser = 'true';
    apply();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
